import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { AnimeScheduleV2 } from '../cmps/HomePage/AnimeScheduleV2'
import { RedDivider } from '../cmps/RedDivider'
import { TopAnimesIndex } from '../cmps/HomePage/TopAnimes/TopAnimesIndex'
import { Articles } from '../cmps/HomePage/Articles'
import { HeroAnnouncements } from '../cmps/HomePage/HeroAnnouncements'
import { TopEditors } from '../cmps/HomePage/TopEditors'
import { DiscoverSection } from '../cmps/HomePage/DiscoverSection'
import NewestPosts from '../cmps/PostSystem/NewestPosts'
import NewestPostsFooter from '../cmps/PostSystem/NewestPostsFooter'
import { images } from '../services/images.service'
import { HomePageHelmet } from '../cmps/Helments/HomePageHelmet'

export function HomePage() {
  return (
    <div className="min-h-screen">
      {/* הגדרת SEO דינמי באמצעות react-helmet-async */}
      <HomePageHelmet />

      {/* שאר תוכן הדף */}
      <NewestPosts />
      <div className="w-full">
        <div className="container mx-auto">
          <HeroAnnouncements />
        </div>
        <RedDivider />
      </div>

      <div className="w-full">
        <div className="container mx-auto">
          <TopAnimesIndex />
        </div>
      </div>

      <div className="w-full">
        <RedDivider />
        <div className="container mx-auto">
          <AnimeScheduleV2 />
        </div>
      </div>

      <div className="w-full">
        <div className="transform rotate-[-2deg]">
          <RedDivider />
        </div>
        <div className="container mx-auto">
          <Articles />
        </div>
        <div className="transform rotate-[-2deg]">
          <RedDivider />
        </div>
      </div>
      <div className="container mx-auto">
        <TopEditors />
      </div>
      <div className="container mx-auto">
        <DiscoverSection />
      </div>
      <div
        style={{
          borderTopWidth: '2px',
          borderTopStyle: 'solid',
          borderBottomWidth: '2px',
          borderBottomStyle: 'solid',
          borderImageSource: `url(${images.redBorder})`,
          borderImageSlice: '20',
          borderImageRepeat: 'stretch',
        }}
        className="my-24 rotate-2 "
      >
        <NewestPostsFooter />
      </div>
    </div>
  )
}
